export enum RequestStatus {
  INTRODUCTED = 1,
  APPROVED = 2,
  FINALLY_APPROWED = 3,
  TO_CHANGE = 4,
  REJECTED = 5,
  FINALLY_REJECTED = 6,
  CANCELED = 7,
}
